
import validator from 'validator';

const validateReason = (data) => {
    let errors = {};

    const { reason} = data;

    if (validator.isEmpty(reason)) {
        errors.reason = '반려 사유를 선택해주세요';
    }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateReason;
